import { Link } from "react-router-dom";

const RfqToast = ({ product, images, formatPrice, productPrice, setIsOpen }) => {
    return(
        <>
            <div
                className="fixed-bottom"
                style={{
                    right: "20px",
                    bottom: "20px",
                    left: "auto",
                    zIndex: 9999,
                    width: "fit-content",
                }}
            >
                <div
                    className="toast show"
                    role="alert"
                    style={{
                        width: "380px",
                        minHeight: "150px", // Increased height
                        //borderLeft: "4px solid #a9cb59",
                        animation: "slideIn 0.3s ease-out",
                        borderRadius: "5px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    }}
                >
                    {/* Toast Header */}
                    <div className="toast-header bg-white border-0 p-20">
                        <div className="d-flex align-items-center w-100 gap-2">
                            <div className="p-10 bg-light-grey rounded-circle d-flex align-items-center">
                                <i className="ph ph-check fs-5 text-black"></i>
                            </div>
                            <div className="flex-grow-1 ml-10">
                                <strong className="me-auto">Added to quotation request</strong>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setIsOpen(false)}
                            >                            
                            </button>
                        </div>
                    </div>

                    {/* Toast Body */}
                    <div
                        className="toast-body bg-light p-20"
                        style={{
                            minHeight: "120px",
                        }}
                    >
                        <div className="d-flex gap-3 align-items-start">
                            <img
                                src={
                                    product?.jasani_image_url || images[0]?.files?.medium?.url
                                }
                                alt="Product"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "cover"
                                }}
                            />
                            <div className="flex-grow-1 ml-10">
                                <div className="d-flex justify-content-between mb-20">
                                    <h6 className="mb-0 fw-semibold mb-10">{product?.name}</h6>                                    
                                </div>

                                <div className="d-flex justify-content-between align-items-center mb-10">
                                    <h4>
                                        {formatPrice(productPrice?.price)}
                                    </h4>                                    
                                </div>                                
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-10">                                   
                            <Link
                                to='/rfq'
                                className="btn w-full px-30 bg-main-product-50 hover-bg-main-product-50 text-white"
                            >
                                View RFQ
                            </Link>                                                     
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RfqToast;